module.exports = __webpack_public_path__ + "img/widget-img_smile.45fbfa3a.png";